import React from "react";
import useLocaleByLanguage from "../../../../../utils/hooks/useLocaleByLanguage";
import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import { useTranslation } from "react-i18next";
import { TbTicket } from "react-icons/tb";
import AddToGoogleCalendar from "../../../shared/CalendarIntegration/AddToGoogleCalendar";
import useDesktopSize from "../../../../../utils/hooks/useDesktopSize";

interface IProps {
  exerciseName: string;
  ticketName: string;
  date: number;
}

const SingleFutureTicketDetails: React.FC<IProps> = ({ exerciseName, ticketName, date }) => {
  const locale = useLocaleByLanguage();
  const { t } = useTranslation();
  const isDesktop = useDesktopSize();

  return (
    <div className="single-future-ticket-details">
      <h5>{exerciseName}</h5>
      <span className="single-future-ticket-details__hour">
        {format(date, "cccc", { locale: locale })}, {t("godz")}:{" "}
        {format(utcToZonedTime(date, "Europe/Warsaw"), "HH:mm")}
      </span>
      <span className="single-future-ticket-details__name">
        <TbTicket /> {ticketName}
      </span>
      <AddToGoogleCalendar
        title={exerciseName}
        startTime={date}
        endTime={date + 60 * 60 * 1000}
        details={""}
        variant="text"
        color="secondary"
        noMargins={isDesktop}
      />
    </div>
  );
};

export default SingleFutureTicketDetails;
